// Main JavaScript file
import * as bootstrap from 'bootstrap';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { initTypingAnimations } from './animations';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', () => {
    // Welcome Modal Logic
    const welcomeModalEl = document.getElementById('welcomeModal');
    // console.log("Modal Debug - Element Found:", !!welcomeModalEl);

    if (welcomeModalEl) {
        const path = window.location.pathname;
        const isHomePage = path === '/' || path.endsWith('/index.html') || path === '' || path.endsWith('/');
        // console.log("Modal Debug - Current Path:", path);
        // console.log("Modal Debug - Is Home Page:", isHomePage);

        if (isHomePage) {
            // console.log("Modal Debug - Scheduling show in 3s...");
            setTimeout(() => {
                try {
                    // console.log("all running", { bootstrap: typeof bootstrap !== 'undefined', Modal: typeof bootstrap !== 'undefined' && !!bootstrap.Modal });
                    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                        const welcomeModal = new bootstrap.Modal(welcomeModalEl);
                        welcomeModal.show();
                        // console.log("Modal Debug - show() called");
                    }
                } catch (err) {
                    // console.error("Modal Debug - Error:", err);
                }
            }, 3000);
        }
    }

    // Initialize all sliders, animations, etc...
    initTypingAnimations();

    // Highlight active nav link based on current page
    const currentPage = window.location.pathname.split('/').pop() || 'index.html';
    document.querySelectorAll('.nav-link').forEach(function (link) {
        const href = link.getAttribute('href');
        if (href && href.split('#')[0] === currentPage) {
            link.classList.add('active');
        }
    });

    // Mobile offcanvas: toggle nested submenus on click
    const offcanvasSubmenus = document.querySelectorAll('#offcanvasNavbar .dropdown-submenu > .dropdown-item');
    offcanvasSubmenus.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const submenu = this.nextElementSibling;
            if (submenu && submenu.classList.contains('dropdown-menu')) {
                submenu.classList.toggle('show');
                this.classList.toggle('active');
            }
        });
    });


    const counters = document.querySelectorAll('.js-counter');

    const observerOptions = {
        threshold: 0.5
    };

    const counterObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = entry.target;
                const countTo = parseInt(target.getAttribute('data-count'));
                const duration = 2000;
                let startTime = null;

                const formatNumber = (num) => {
                    if (countTo === 10) return num + 'M+';
                    if (countTo === 50000) return num.toLocaleString() + '+';
                    return num + '+';
                };

                const animation = (currentTime) => {
                    if (!startTime) startTime = currentTime;
                    const progress = Math.min((currentTime - startTime) / duration, 1);
                    const currentCount = Math.floor(progress * countTo);

                    target.innerText = formatNumber(currentCount);

                    if (progress < 1) {
                        requestAnimationFrame(animation);
                    } else {
                        target.innerText = formatNumber(countTo);
                    }
                };

                requestAnimationFrame(animation);
                observer.unobserve(target);
            }
        });
    }, observerOptions);

    counters.forEach(counter => {
        counterObserver.observe(counter);
    });

    // Navbar Hide/Show on Scroll
    let lastScrollTop = 0;
    const navbar = document.querySelector('header.fixed-top');
    if (navbar) {
        const delta = 5;
        const navbarHeight = navbar.offsetHeight;

        window.addEventListener('scroll', function () {
            let st = window.pageYOffset || document.documentElement.scrollTop;

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta) return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                navbar.classList.add('nav-up');
            } else {
                // Scroll Up
                if (st + window.innerHeight < document.documentElement.scrollHeight) {
                    navbar.classList.remove('nav-up');
                }
            }

            lastScrollTop = st;
        });
    }


    const solutionsSwiper = new Swiper('.solutions-swiper', {
        modules: [Autoplay],
        slidesPerView: 1.2,
        spaceBetween: 24,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            stopOnLastSlide: false,
        },
        allowTouchMove: false,
        grabCursor: false,
        watchSlidesProgress: true,
        breakpoints: {
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2.2 },
            1024: { slidesPerView: 3 },
            1400: { slidesPerView: 3 },
        }
    });

    // Manual restart listeners removed in favor of pauseOnMouseEnter: true

    // Hero
    const heroSwiper = new Swiper('.swiper.hero-slider', {
        modules: [Pagination, Autoplay, EffectFade],
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            stopOnLastSlide: false,
        },
        watchSlidesProgress: true,
        pagination: { el: '.hero-pagination', clickable: true },
    });

    // Manual restart removed

    // Testimonials
    const testimonialSwiper = new Swiper('.swiper.testimonial-swiper', {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 8000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            stopOnLastSlide: false,
        },
        allowTouchMove: false,
        watchSlidesProgress: true,
        pagination: { el: '.testimonial-pagination', type: 'progressbar' },
        breakpoints: {
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2.5 },
            1024: { slidesPerView: 3.5 },
        }
    });

    // Manual restart removed

    // Global Certifications - Static Section (Swiper Removed)

    // EPE Swiper
    const epeSwiper = new Swiper('.epe-swiper', {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 800,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            stopOnLastSlide: false,
        },
        watchSlidesProgress: true,
        pagination: { el: '.epe-pagination', type: 'progressbar' },
        breakpoints: {
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2.2 },
            1024: { slidesPerView: 3 },
        }
    });

    // Manual restart removed

    // Warehouse Logic
    const thumb1 = document.getElementById('warehouseThumb1');
    const thumb2 = document.getElementById('warehouseThumb2');
    const warehouseImages = document.querySelectorAll('.warehouse-bg-image');

    if (thumb1 && thumb2 && warehouseImages.length > 0) {
        let currentIndex = 0;
        let autoChangeInterval;
        const totalImages = warehouseImages.length;

        const updateUI = () => {
            warehouseImages.forEach((img, idx) => {
                img.classList.toggle('active', idx === currentIndex);
            });
            // Clear previous thumbnail classes
            for (let i = 1; i <= totalImages; i++) {
                thumb1.classList.remove(`warehouse-thumb-${i}`);
                thumb2.classList.remove(`warehouse-thumb-${i}`);
            }
            const nextIndex = (currentIndex + 1) % totalImages;
            thumb1.classList.add(`warehouse-thumb-${currentIndex + 1}`);
            thumb2.classList.add(`warehouse-thumb-${nextIndex + 1}`);
        };

        const nextSlide = () => {
            currentIndex = (currentIndex + 1) % totalImages;
            updateUI();
        };

        const startAutoChange = () => {
            clearInterval(autoChangeInterval);
            autoChangeInterval = setInterval(nextSlide, 5000);
        };

        thumb2.addEventListener('click', () => {
            nextSlide();
            startAutoChange();
        });

        updateUI();
        startAutoChange();
    }

    // Brands Stacking
    const brandsWrapper = document.querySelector('.brands-stack-wrapper');
    const brandCards = document.querySelectorAll('.brand-stack-item');

    if (brandsWrapper && brandCards.length > 0) {
        let mm = gsap.matchMedia();
        mm.add("(min-width: 992px)", () => {
            brandCards.forEach((card, index) => {
                if (index < brandCards.length - 1) {
                    const nextCard = brandCards[index + 1];
                    const cardInner = card.querySelector('.brand-card');
                    gsap.to(cardInner, {
                        scale: 0.95,
                        opacity: 1,
                        y: -20,
                        scrollTrigger: {
                            trigger: nextCard,
                            start: "top 95%",
                            end: "top 15%",
                            scrub: true,
                        }
                    });
                }
            });
        });
    }

    // Lenis Smooth Scroll
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
    });

    const offcanvasEl = document.getElementById('offcanvasNavbar');
    if (offcanvasEl) {
        offcanvasEl.addEventListener('show.bs.offcanvas', () => lenis.stop());
        offcanvasEl.addEventListener('hidden.bs.offcanvas', () => lenis.start());
    }

    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);

    // Product Filtering
    const productTabs = document.querySelectorAll('.btn-tab');
    const productItems = document.querySelectorAll('.product-item');

    if (productTabs.length > 0) {
        const filterProducts = (category) => {
            productItems.forEach(item => {
                item.classList.toggle('show', item.getAttribute('data-category') === category);
            });
        };
        filterProducts('essel');
        productTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                productTabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
                filterProducts(tab.getAttribute('data-filter'));
            });
        });
    }

    // EmailJS
    if (typeof emailjs !== "undefined") {
        emailjs.init("DDz_jpC9VsYXsBtm5");
    }

    const contactForm = document.getElementById("contact-form");
    if (contactForm) {
        contactForm.addEventListener("submit", function (event) {
            event.preventDefault();
            emailjs.sendForm("service_gugmkdz", "template_eie1lgu", contactForm)
                .then(() => {
                    alert("Message Sent Successfully!");
                    contactForm.reset();
                })
                .catch((error) => {
                    // console.error("EmailJS Error:", error);
                    alert("Failed to send message.");
                });
        });
    }
});

export { bootstrap };
